import React from "react";

const styles: Record<string, string> = {
  PENDING: "bg-amber-500/15 text-amber-200 ring-amber-400/35",
  UNDER_REVIEW: "bg-violet-500/15 text-violet-200 ring-violet-400/35",
  RESOLVED: "bg-emerald-500/15 text-emerald-200 ring-emerald-400/35",
  REJECTED: "bg-rose-500/15 text-rose-200 ring-rose-400/35",
  OPEN: "bg-slate-500/20 text-slate-200 ring-white/20",
  IN_PROGRESS: "bg-sky-500/15 text-sky-200 ring-sky-400/35",
  ASSIGNED: "bg-indigo-500/15 text-indigo-200 ring-indigo-400/35",
};

export default function AdminClientRequestStatusBadge(props: {
  status: string;
  label?: string;
}): React.JSX.Element {
  const k = String(props.status ?? "").toUpperCase();
  const cls = styles[k] ?? "bg-white/10 text-slate-200 ring-white/15";
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ring-1 ${cls}`}
    >
      {props.label ?? props.status}
    </span>
  );
}
